import { store } from 'lib/stores';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import PWAUpdatePrompt from 'shared/components/PWAUpdatePrompt';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import '@fontsource/roboto-mono/400.css';
import 'nprogress/nprogress.css';
import 'styles/global.scss';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <App />
  </Provider>
);

// Mount PWA update prompt separately to avoid being blocked by auth providers
const pwaRoot = document.createElement('div');
pwaRoot.id = 'pwa-prompt-root';
document.body.appendChild(pwaRoot);
ReactDOM.createRoot(pwaRoot).render(<PWAUpdatePrompt />);
